export const hasValue = (value: string) => Boolean(value)
